import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const AdminPagesListHeader = ({
  orderBy,
  order,
  handleChangeOrder,
}) => {
  const intl = useIntl();

  const changeOrder = (e, field) => {
    e.preventDefault();
    handleChangeOrder(field, order === 'asc' ? 'desc' : 'asc');
  };

  return (
    <tr>
      <th className={`th-sortable${orderBy === 'name' ? ' active' : ''}`}>
        <a href="#sort" onClick={(e) => { changeOrder(e, 'name'); }}>
          {intl.formatMessage({ defaultMessage: 'Name' })}
          {' '}
          {orderBy === 'name' && (
            <i className={`fas fa-long-arrow-${order === 'asc' ? 'down' : 'up'}`} />
          )}
        </a>
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'URL' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Visibility' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Views' })}
      </th>
      <th>
        {' '}
      </th>
      <th>
        {' '}
      </th>
    </tr>
  );
};

AdminPagesListHeader.propTypes = {
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  handleChangeOrder: PropTypes.func.isRequired,
};

export default AdminPagesListHeader;
